import { render, staticRenderFns } from "./createCourse.vue?vue&type=template&id=5292956a"
import script from "./createCourse.vue?vue&type=script&lang=js"
export * from "./createCourse.vue?vue&type=script&lang=js"
import style0 from "./createCourse.vue?vue&type=style&index=0&id=5292956a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports